<script lang="ts">
  interface Props { label?: string; animated?: boolean }
  let { label = 'RSVjelle emblem', animated = false }: Props = $props();
</script>

<div class:logo-animated={animated} class="logo-frame" role="img" aria-label={label}>
  <svg class="realm-logo" viewBox="0 0 64 64" aria-hidden="true">
    <defs><clipPath id="realm-monogram-clip"><path d="M32 9 55 32 32 55 9 32Z" /></clipPath></defs>
    <path class="logo-diamond" d="M32 3 61 32 32 61 3 32Z" />
    <path class="logo-cut" d="M32 9 55 32 32 55 9 32Z" />
    <g clip-path="url(#realm-monogram-clip)">
      <path class="logo-r" d="M21 42V22h9c5 0 8 2.5 8 6s-3 6-8 6h-9m9 0 8 8" />
      <path class="logo-v" d="m34 24 6 16 6-16" />
    </g>
    <path class="logo-shard" d="m32 8 3 7-3 5-3-5Z" />
  </svg>
</div>
